import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatabaseService } from '../database.service';
import { LatestData } from '../newdata';
import { firestore } from 'firebase';

@Component({
  selector: 'app-updatecases',
  templateUrl: './updatecases.component.html',
  styleUrls: ['./updatecases.component.css']
})
export class UpdatecasesComponent implements OnInit {

  constructor(private http:HttpClient,private database:DatabaseService) { }

  ngOnInit(): void {
    //this.deleteAllFromAgeos();
    //this.updateNewCases();
  }



  deleteAllFromAgeos(){
      this.database.getInvections().subscribe((data)=>{
      data.forEach(infection => {
        let infectionData = infection.data();
        if (infectionData.ageos==true) {
          this.database.deleteInfection(infection.id);
          console.log(infection);
          
        }
      
      })
    })

  }



  updateNewCases(){
    
for (let i = 0; i < LatestData.data.features.length; i++) {
  var sex;
  if (LatestData.data.features[i].properties.genre==="Homme") {
    sex=1;
  }else{
    sex=2
  }
  this.database.addNewInfection({
    userinformations: {
      fullname: "inconnue",
      sex: sex,
      age: LatestData.data.features[i].properties.age,
      phone: "inconnue",
      region: LatestData.data.features[i].properties.question_sans_titre_5,
      s1: true,
      s2: true,
      s3: true,
      s4: true,
      s5: true,
      s6: true,
      s7: true,

    },
    position: new firestore.GeoPoint(LatestData.data.features[i].geometry.coordinates[1], LatestData.data.features[i].geometry.coordinates[0]),
    stat: 2,
    addDate: new Date(LatestData.data.features[i].properties.Confirm_Date),
    ageos:true
  })
  
}

  }

}
